var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-slide-top"}},[(_vm.isShow)?_c('div',{staticClass:"notification",class:{
			'is-success': _vm.isSuccess,
			'is-danger': _vm.isError
		}},[_c('button',{staticClass:"delete",on:{"click":_vm.closeNotification}}),_vm._v("\n\t\t"+_vm._s(_vm.message)+"\n\t")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }